<script>
  import { Menu } from "../../services/bootstrap.js"
  import { createEventDispatcher } from "svelte"
  import { BASE_URL } from "../../stores/BASE_URL"
  import { user } from "../../stores/User"
  export let cliente

  const dispatch = createEventDispatcher()

  let etapas_db = []
  let etapa_seleccionada = "Postventa"

  const etapas = {
    "Posible cliente": ["Nuevo", "Contactado"],
    "En proceso": [
      "Calificado",
      "Propuesta enviada",
      "Demostración",
      "En negociación",
    ],
    Cierre: ["Acuerdo", "Acuerdo exitoso"],
    Perdido: ["Cliente perdido"],
    Postventa: ["Fidelización"],
  }

  const colores = {
    "Posible cliente": "secondary",
    "En proceso": "yellow",
    Cierre: "success",
    Perdido: "danger",
    Postventa: "neutral",
  }

  let buttons = {
    "Posible cliente": false,
    "En proceso": false,
    Cierre: false,
    Perdido: false,
    Postventa: true,
  }

  function seleccionar(etapa, clasificacion, event) {
    cliente.etapa = etapa
    cliente.clasificacion = clasificacion
    const btn = event.target.closest(".btn-group")?.querySelector(".btn-etapa")
    if (btn) {
      const instance = Menu.getOrCreateInstance(btn)
      instance.hide()
    }
    actualizarCicloVenta()
  }

  const actualizarCicloVenta = () => {
    dispatch("update", {
      etapa: cliente.etapa,
      clasificacion: cliente.clasificacion,
      id_etapa: etapas_db.find(
        (e) =>
          e.etapa === cliente.etapa &&
          e.clasificacion === cliente.clasificacion,
      ).id,
    })
    etapa_seleccionada = cliente.etapa
    btnsBloqueados()
  }

  const getEtapas = async () => {
    const response = await fetch(
      `${BASE_URL}crm.php?ops=getEtapas&session_key=${$user.session_key}`,
    )
    const data = await response.json()
    if (data.status === "ok") {
      etapas_db = data.data
      etapa_seleccionada = cliente.etapa
    } else {
      console.error("Error al obtener etapas:", data.message)
    }
  }

  const btnsBloqueados = () => {
    for (let key in buttons) {
      buttons[key] = true
    }

    switch (cliente.etapa) {
      case "Posible cliente":
        buttons["Posible cliente"] = false
        buttons["En proceso"] = false
        buttons["Cierre"] = false
        buttons["Perdido"] = false
        break
      case "En proceso":
        buttons["Posible cliente"] = false
        buttons["En proceso"] = false
        buttons["Cierre"] = false
        buttons["Perdido"] = false
        break
      case "Cierre":
        if (cliente.clasificacion === "Acuerdo exitoso") {
          buttons["Postventa"] = false
        } else {
          buttons["Posible cliente"] = false
          buttons["En proceso"] = false
          buttons["Cierre"] = false
          buttons["Perdido"] = false
        }
        break
      case "Perdido":
        buttons["Posible cliente"] = false
        buttons["En proceso"] = false
        buttons["Cierre"] = false
        buttons["Perdido"] = false
        break
    }
  }

  getEtapas()
  btnsBloqueados()
</script>

<div class="d-flex flex-wrap gap-3 justify-content-center">
  {#each Object.entries(etapas) as [etapa, clasificaciones], index}
    <div class="btn-group me-3 position-relative">
      <button
        type="button"
        class="btn btn-sm {cliente.etapa === etapa ? 'btn-solid' : 'btn-outline'} theme-{colores[etapa]} btn-etapa rounded-end"
        data-bs-toggle="menu"
        aria-expanded="false"
        disabled={buttons[etapa]}
      >
        {etapa}
        <hr class="menu-divider m-0" />
        <small>{cliente.etapa === etapa ? cliente.clasificacion : ""}</small>
      </button>

      <div class="menu">
        {#each clasificaciones as clasificacion}
            <button
              type="button"
              class="menu-item {etapa_seleccionada == 'Postventa'
                ? 'disabled'
                : ''}"
              on:click={(event) => seleccionar(etapa, clasificacion, event)}
            >
              {clasificacion}
              {#if cliente.etapa === etapa && cliente.clasificacion === clasificacion}
                <i class="bi bi-check-circle ms-1 fg-success"></i>
              {/if}
            </button>
        {/each}
      </div>
    </div>

    {#if index < Object.entries(etapas).length - 1}
      <div class="d-flex align-items-center me-3 fg-secondary">
        <i class="bi bi-chevron-compact-right"></i>
      </div>
    {/if}
  {/each}
</div>

<style>
  .btn-etapa {
    min-width: 145px;
    flex-direction: column;
  }
</style>
